module.exports = __webpack_public_path__ + "static/media/tlyfeImageText3.280125bd.png";